<template>
  <div class="report-card">
    <div class="report-header">
      <span class="report-type">{{ type }}</span>
      <button class="btn-icon btn-danger" @click="$emit('deleteReport', id)" title="Usuń zgłoszenie">
        <img src="@/assets/icons/trash.svg" alt="usuń">
      </button>
    </div>

    <p class="report-comment">
      {{ comment.length > 300 ? comment.slice(0, 300) : comment }}
    </p>

    <div class="report-footer">
            <span class="report-date">
                {{ date.slice(0, -10).split('T')[0] }}<br>{{ date.slice(0, -10).split('T')[1] }}
            </span>
      <ButtonVue
          @click="() => $router.push(`/admin-profile/reports/${id}`)"
          color="#fff"
          bg-color="#f97316"
          text="Podgląd"
      />
    </div>
  </div>
</template>

<script>
import ButtonVue from '../Button.vue';

export default {
  name: 'ReportCard',
  props: ['comment', 'date', 'id', 'type'],
  components: {
    ButtonVue,
  },
};
</script>

<style scoped lang="scss">
.report-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 14px;
  width: 100%;
  box-sizing: border-box;
  transition: box-shadow 0.2s, border-color 0.2s;
}

.report-card:hover {
  border-color: #10b981;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.report-type {
  display: inline-block;
  background-color: #d1fae5;
  color: #065f46;
  font-size: 1.2rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.report-comment {
  margin: 0;
  color: #374151;
  font-size: 1.45rem;
  line-height: 1.5;
  word-break: break-word;
}

.report-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  padding-top: 10px;
  border-top: 1px solid #e5e7eb;
}

.report-date {
  display: inline-block;
  color: #6b7280;
  font-size: 1.3rem;
  line-height: 1.4;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
}

.btn-icon img {
  width: 20px;
  height: 20px;
}

.btn-icon:hover {
  background-color: #f3f4f6;
}

.btn-danger:hover {
  background-color: #fee2e2;
}

@media (max-width: 480px) {
  .report-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .report-date {
    text-align: center;
  }
}
</style>